import { ReactElement } from 'react';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import { SxProps, Theme } from '@mui/material';

interface StateToggleIconProps {
  isOn: boolean;
  onIconSx: SxProps<Theme>;
  offIconSx: SxProps<Theme>;
}

export function StateToggleIcon({
  isOn,
  onIconSx,
  offIconSx,
}: StateToggleIconProps): ReactElement {
  return isOn ? <ToggleOnIcon sx={onIconSx} /> : <ToggleOffIcon sx={offIconSx} />;
}
